import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="py-16 md:py-24" data-testid="terms-page">
      <div className="container-tight max-w-3xl">
        <div className="overline">Legal</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mt-3 leading-[1.02]">
          Terms of <span className="text-primary">use</span>.
        </h1>
        <p className="mt-6 text-foreground/60 text-sm">Last updated: 27 July 2026</p>

        <div className="mt-8 border-l-2 border-secondary bg-secondary/10 p-5 text-sm text-foreground/80">
          <span className="font-semibold">Template.</span> This is a working draft written in the site&apos;s voice.
          Please have it reviewed by a qualified legal professional before treating it as your final published terms.
        </div>

        <div className="mt-12 space-y-10 text-foreground/80 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">1. Who these terms are with</h2>
            <p>
              These terms are a contract between you and Talk Golf International (Dublin, Ireland), the operator of
              the TGI Golfer Fund website. By creating an account, submitting an application, donating or
              sponsoring, you agree to be bound by them.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">2. Who can use the platform</h2>
            <p>
              You must be at least 18 years old to create an account or make a donation. Golfers under 18 may apply
              through a parent, guardian or coach. You must give accurate information and keep it up to date.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">3. Accounts &amp; security</h2>
            <p>
              You&apos;re responsible for keeping your password confidential and for anything that happens under
              your account. Tell us straight away if you think it&apos;s been compromised. We may suspend or close
              accounts that break these terms or put other users at risk.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">4. Golfer applications &amp; verification</h2>
            <p>
              Golfer profiles do not go live automatically. We review every application against the criteria
              published on the About page. We may accept, reject or ask for more information at our discretion.
              Approval doesn&apos;t guarantee any level of funding or media exposure.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">5. Donations &amp; sponsorships</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Donations and sponsorships are voluntary contributions to individual golfers, not to Talk Golf International.</li>
              <li>Once processed, donations are non-refundable except where required by law.</li>
              <li>Monthly support can be cancelled at any time from your dashboard.</li>
              <li>Sponsorship tiers include the perks listed on the Sponsorship page for the duration stated.</li>
              <li>We may charge a small transaction fee to cover payment processing and platform costs.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">6. Content</h2>
            <p>
              Golfers own the story, images and updates they post. By publishing them on the platform they give us
              a non-exclusive licence to display and promote them on the site and, where relevant, on Talk Golf
              International&apos;s channels. Don&apos;t publish anything that is unlawful, defamatory or infringes
              someone else&apos;s rights.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">7. Prohibited conduct</h2>
            <p>Don&apos;t:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Misrepresent yourself, your rankings or your affiliations.</li>
              <li>Attempt to scrape, reverse engineer or interfere with the platform.</li>
              <li>Use the platform to launder funds or move money in breach of law.</li>
              <li>Harass or contact other users outside the intended channels.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">8. Availability &amp; changes</h2>
            <p>
              We aim to keep the platform running but we don&apos;t promise it will always be available or bug-free.
              We may add, change or remove features. Material changes to these terms will be notified to registered
              users before they take effect.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">9. Our liability</h2>
            <p>
              Nothing in these terms limits liability for fraud, death or personal injury caused by our negligence,
              or any other liability that can&apos;t be limited under Irish law. Otherwise our aggregate liability
              is limited to the total transaction fees you have paid us in the 12 months before the claim.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">10. Governing law</h2>
            <p>
              These terms are governed by the laws of Ireland. The courts of Ireland have exclusive jurisdiction
              over any dispute, without prejudice to any consumer rights you have to bring proceedings in your
              local courts.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl mb-4 text-foreground">11. Contact</h2>
            <p>
              Questions about these terms? Email{" "}
              <a href="mailto:golfersfund@talkgolfireland.com" className="text-primary underline">
                golfersfund@talkgolfireland.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8 flex flex-wrap gap-3">
          <Link to="/" className="btn-outline uppercase tracking-[0.18em] text-[12px]" data-testid="terms-home-link">Back to home</Link>
          <Link to="/privacy" className="btn-outline uppercase tracking-[0.18em] text-[12px]">Privacy</Link>
          <Link to="/cookies" className="btn-outline uppercase tracking-[0.18em] text-[12px]">Cookies</Link>
        </div>
      </div>
    </div>
  );
}
